import React from "react";
import { Download, ArrowLeft } from "lucide-react";
import { GUIDELINES_PDF_URL } from "../data/brandKit";
import "./BrandGuidelines.css";

// The brand book is a single self-contained HTML file -- inline SVG figures, DM Sans from
// Google Fonts, no other external assets. It is served AS-IS from /brand/ and framed here so
// its figures render exactly as designed: the logo versions, the clear-space diagram, the nine
// prohibited uses, the colour swatches and tint ramps, the type specimens, the voice do/don't
// cards, the claims lists, the three badges, the photography shot list and the four
// application mock-ups.
//
// It is deliberately NOT re-typeset into portal components. Re-typesetting a brand book is how
// a brand book stops being the brand book -- the whole point of the document is that what you
// see is what the rules say.
//
// It also honours the viewer's light/dark theme on its own, so nothing here touches its
// colours.
const BRAND_BOOK_SRC = "/brand/HG_Brand_Book_V3.html";

export default function BrandGuidelines({ onBack }) {
  return (
    <div className="brand-guidelines" data-testid="brand-guidelines">
      <header className="bg-header">
        <div className="bg-header-left">
          {onBack && (
            <button className="btn btn-text" onClick={onBack}>
              <ArrowLeft size={14} strokeWidth={1.8} /> Brand &amp; Marketing
            </button>
          )}
          <h2>Brand Guidelines</h2>
        </div>
        <a className="btn btn-primary" href={GUIDELINES_PDF_URL.replace("/upload/", "/upload/fl_attachment/")}>
          <Download size={15} strokeWidth={1.8} /> Download PDF
        </a>
      </header>

      <iframe
        className="bg-frame"
        src={BRAND_BOOK_SRC}
        title="Henry-Griffitts Brand Book V3"
        loading="lazy"
      />
    </div>
  );
}
